import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IWrapper } from '../../interfaces';
import { FormPreviewWrapper } from './FormPreviewWrapper';
import { Intro } from './Intro';
import { Categorize } from './Categorize';
import { Generate } from './Generate';
import { GENERATE_FORM_STEPS, STYLES } from '../../consts';

const { GENERATE } = STYLES;

export const Wrapper = ({ activeFormData, shouldSkipIntro }: IWrapper) => {
  const { generateStep } = useParams();
  const navigate = useNavigate();
  const { formType } = useParams();

  const renderStep = () => {
    if (!generateStep && !shouldSkipIntro) {
      return <Intro />;
    }
    if (generateStep === GENERATE_FORM_STEPS.CATEGORIZE || (!generateStep && shouldSkipIntro)) {
      return <Categorize filterYear={activeFormData.year} />;
    }
    if (generateStep === GENERATE_FORM_STEPS.GENERATE) {
      return <Generate formType={formType || ''} formId={activeFormData.formId} year={activeFormData.year} />;
    }
    // Return Intro as default step
    return <Intro />;
  };

  useEffect(() => {
    navigate(`/tax-forms/${formType}`);
    renderStep();
  }, [activeFormData]);

  return (
    <div className={GENERATE.WRAPPER}>
      {activeFormData?.fileCreated && <FormPreviewWrapper formId={activeFormData.formId} />}
      {!activeFormData?.fileCreated && renderStep()}
    </div>
  );
};
